import { ChangeEvent, Dispatch, SetStateAction, SubmitEvent } from "react";

import { Trans, useTranslation } from "react-i18next";

import { useAuth } from "../../../../../context/Auth/AuthProvider";
import { OtpInputField } from "../../../../../shared/auth/OtpInputField";
import {
  AUTHENTICATION_TYPES,
  ENABLE_AUTHENTICATION_STEPS
} from "../../../types";
import { BorderFrame } from "../components/BorderFrame";
import { Buttons } from "../components/Buttons";
import { InnerBottom } from "../components/InnerBottom";
import { InnerTop } from "../components/InnerTop";

interface SendEmailCodeProps {
  isLoading: boolean;
  error: string | null;
  otpCode: string;
  authType: AUTHENTICATION_TYPES | null;
  changeOtpCode: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onBlur: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  changeStep: (newStep: ENABLE_AUTHENTICATION_STEPS) => void;
  sendOtpCodeSubmit: () => void;
  setError: Dispatch<SetStateAction<string | null>>;
}

const SendEmailCode = ({
  isLoading,
  error,
  otpCode,
  authType,
  changeOtpCode,
  changeStep,
  onBlur,
  sendOtpCodeSubmit,
  setError
}: SendEmailCodeProps) => {
  const { user } = useAuth();

  const { t } = useTranslation();

  const handleSecondaryButtonClick = () => {
    changeStep(ENABLE_AUTHENTICATION_STEPS.GetEmailCode);
    setError(null);
  };

  const handleSubmit = (e: SubmitEvent<HTMLFormElement>) => {
    e.preventDefault();
    sendOtpCodeSubmit();
  };

  return (
    <form onSubmit={handleSubmit} data-testid="send-email-code-form">
      <BorderFrame>
        <InnerTop
          title={
            <Trans
              i18nKey="Security##2FA##send email code##title"
              values={{ email: user?.email }}
              components={{
                1: <span />
              }}
            />
          }
          description={t("Security##2FA##send email code##description")}
        />

        <InnerBottom>
          <OtpInputField
            isLoading={isLoading}
            error={error}
            value={otpCode}
            onChange={changeOtpCode}
            onBlur={onBlur}
            label={t("Security##2FA##send email code##verification code")}
            isRequired
          />
        </InnerBottom>
      </BorderFrame>

      <Buttons
        isLoadingPrimary={isLoading}
        isPrimaryBtnDisabled={
          Boolean(error) || authType === null || otpCode.length < 6
        }
        primaryBtnTitle={t("Button##verify")}
        secondaryBtnTitle={t("Button##back")}
        onSecondaryBtnClick={handleSecondaryButtonClick}
      />
    </form>
  );
};

export { SendEmailCode };
